import React from "react";
import { BULGARIA_COUNTRY_ID } from "utils/constants";
import { useGetMany, useRecordContext } from "react-admin";
import { administrationRequests } from "api/administrationApi";

const LocationsField = ({ source }) => {
  const record = useRecordContext();
  const locations = record?.[source] || [];
  const countryIds = locations.map(loc => loc?.countryId).filter(Boolean);
  const settlementIds = locations
    .filter(loc => loc?.countryId === BULGARIA_COUNTRY_ID && loc?.settlementId)
    .map(loc => loc.settlementId);

  const { data: countries } = useGetMany(administrationRequests.getCountriesSelect(), { ids: countryIds });
  const { data: settlements } = useGetMany(administrationRequests.getSettlementsSelect(), { ids: settlementIds });

  const fullLocation = locations
    .map(location => {
      const country = countries?.find(c => c.id === location?.countryId);
      const isTripInternal = location?.countryId === BULGARIA_COUNTRY_ID;
      const settlement = isTripInternal ? settlements?.find(s => s.id === location?.settlementId) : null;
      return [country?.nameBg, settlement?.nameBg].filter(Boolean).join(", ");
    })
    .filter(Boolean)
    .join(" | ");

  return <span>{fullLocation}</span>;
};

export default LocationsField;
